import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

    transform(value: string, searchTerm: string): string {
        if (value === null || value === undefined) {
            return '';
        }

        const text = `${value}`;
        if (!text) {
            return text;
        }

        const keywords = searchTerm ? this.keywords(searchTerm) : [];
        if (!keywords.length) {
            return this.escapeHtml(text);
        }

        const regex = new RegExp(keywords.map(keyword => this.escape(keyword)).join('|'), 'gi');

        let result = '';
        let index = 0;
        let match: RegExpExecArray;

        while ((match = regex.exec(text)) !== null) {
            if (!match[0].length) {
                regex.lastIndex++;
                continue;
            }
            result += this.escapeHtml(text.slice(index, match.index));
            result += `<span class="highlight">${this.escapeHtml(match[0])}</span>`;
            index = match.index + match[0].length;
        }

        return result + this.escapeHtml(text.slice(index));
    }

    private keywords(searchTerm: string): string[] {
        return (searchTerm.match(/"[^"]*"|\S+/g) || [])
            .map(keyword => keyword.replace(/"/g, '').trim())
            .filter(keyword => !!keyword)
            .sort((a, b) => b.length - a.length);
    }

    private escape(keyword: string): string {
        return keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    // The result is rendered with innerHTML, so anything coming from the value itself has to be escaped.
    private escapeHtml(text: string): string {
        return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

}
